const keyMirror = require('keymirror');

export const EVENTS = keyMirror({
    FILTERED_REPORTS: null
});